/**
 * Supabase Client
 * ===============
 * Single source of truth for Supabase client initialization.
 * Import this wherever you need Supabase access.
 */

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
const CLIENT_KEY = '__GLOWGHOST_SUPABASE_CLIENT__';
const SIGNATURE_KEY = '__GLOWGHOST_SUPABASE_CLIENT_SIGNATURE__';
const MISSING_CREDS_WARNED_KEY = '__GLOWGHOST_SUPABASE_MISSING_CREDS_WARNED__';

function getSupabaseSignature(url, anonKey) {
  if (!url || !anonKey) return null;
  return `${url}::${anonKey}`;
}

export function getSupabaseClient() {
  const signature = getSupabaseSignature(SUPABASE_URL, SUPABASE_ANON_KEY);

  if (!signature) {
    if (!globalThis[MISSING_CREDS_WARNED_KEY]) {
      console.warn('⚠️ Supabase credentials not found. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env');
      globalThis[MISSING_CREDS_WARNED_KEY] = true;
    }
    return null;
  }

  if (globalThis[SIGNATURE_KEY] === signature && globalThis[CLIENT_KEY]) {
    return globalThis[CLIENT_KEY];
  }

  const client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
  globalThis[CLIENT_KEY] = client;
  globalThis[SIGNATURE_KEY] = signature;
  return client;
}

export const supabase = getSupabaseClient();
